import React from 'react';
import styled, { StylesProps } from '../../../lib/styles';
import Spacer from '../../../components/presentational/Spacer';
import Ad, { Ad as AdData } from '../../../components/presentational/Ad';

import adhesionAdStyles from './AdhesionAd_styles';

export interface AdhesionAdProps {
  ad: AdData;
  collapsed?: boolean;
}

const AdhesionAd = ({
  ad,
  styles,
}: AdhesionAdProps & StylesProps<typeof adhesionAdStyles>) => (
  <Spacer key={'adhesion_ad'} className={`adhesion_ad ${styles.container}`}>
    <Ad
      ad={ad}
      className={styles.fillAd}
      initialSize={[320, 50]}
      gutter={false}
      inline
      predefined
    />
  </Spacer>
);

export default styled(adhesionAdStyles)(AdhesionAd);
